import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const Help = () => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        e.preventDefault();
        navigate(-1); // go back to previous page
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                minHeight: '80vh',
                padding: '32px',
            }}
        >
            <Typography variant="h5" sx={{ fontFamily: 'Poppins, sans-serif', mb: 2 }}>
                The help for the BIDT Portal will use an external help system which is not included in this demonstration prototype.
            </Typography>
            <Typography variant="h6" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                To continue using the prototype, please return to the{' '}
                <MuiLink
                    component={Link}
                    to="/"
                    sx={{
                        color: '#489596',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    homepage
                </MuiLink>{' '}
                or we can take you{' '}
                <MuiLink
                    href="#"
                    onClick={handleBack}
                    sx={{
                        color: '#489596',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    back
                </MuiLink>{' '}
                to where you were.
            </Typography>
        </Box>
    );
};

export default Help;
